import { render } from "./TheNhomDanToc.vue?vue&type=template&id=f2049f28"
import script from "./TheNhomDanToc.vue?vue&type=script&lang=js"
export * from "./TheNhomDanToc.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__